import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartBars = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M20 3C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21C18.8954 21 18 20.1046 18 19V5C18 3.89543 18.8954 3 20 3Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 11C5.10457 11 6 11.8954 6 13L6 19C6 20.1046 5.10457 21 4 21C2.89543 21 2 20.1046 2 19L2 13C2 11.8954 2.89543 11 4 11Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7C13.1046 7 14 7.89543 14 9V19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19L10 9C10 7.89543 10.8954 7 12 7Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
const ForwardRef = forwardRef(SvgChartBars);
export default ForwardRef;
